import { render, staticRenderFns } from "./CorporateActivities.vue?vue&type=template&id=6a027847&lang=pug&"
import script from "./CorporateActivities.vue?vue&type=script&lang=ts&"
export * from "./CorporateActivities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports